import React from 'react'
import { NavLink,useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CImage,
	CForm,
	CButton,
	CFormInput,
	CInputGroup,
	CLink,
	CTooltip,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import {
	MyButton,
} from '../../components/index'
import { Konfirm } from '../../helpers/onConfirm'
import { UFunc } from '../../helpers/functions'

const pjson 	= require('../../../package.json')
const Headersublapkasir = (props) => {
	const { 
		setToken,setLoading, showToast 
	} = props 

	//--DOM--/
	const uNavigate 			= useNavigate()
	const uDispatch 			= useDispatch()
	//--END DOM--/

	const uHeaderActionObj  	= useSelector(state => state.gInitHeaderAction)
	const uBahasaob  			= useSelector(state => state.listBahasa)
	const uActiveroute			= useSelector(state => state.activeRoute)
	const uKeywordObj			= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uTokenObj				= JSON.parse(localStorage.getItem("token")||"{}");
	const uEfekapp				= useSelector(state => state.effectApp);
	
	const hdlKlikView = () => {
		const vHeaderTmpObj	= uHeaderActionObj;

		vHeaderTmpObj.isHeaderView = true;
		uDispatch({type: "set", gInitHeaderAction: vHeaderTmpObj});
		uDispatch({type: "set", effectApp: !uEfekapp});
	}
	const hdlKlikReset = async() => {
		const vHeaderTmpObj	= uHeaderActionObj;

		vHeaderTmpObj.isHeaderreset = true;
		uDispatch({type: "set", gInitHeaderAction: vHeaderTmpObj});
		uDispatch({type: "set", effectApp: !uEfekapp});
	}

	//console.log("Headersublapkasir - uActiveroute => "+(uActiveroute));
	return (
		<>
		<div className="d-none d-lg-block">
		<CImage src={pjson.homepage+"api/images/menus_"+(uActiveroute||"").toLowerCase()+".png"} 
			className="me-2 align-middle"
			height={30}/>
		<span className="fw-bolder">{uBahasaob["menus_"+(uActiveroute||"").toLowerCase()]||""}</span>
		</div>

		<div className="me-1">
			<MyButton className="py-0"
				iconname="cilFeaturedPlaylist"
				onClick={()=>hdlKlikView()}
				id="btnFilter">
			{uBahasaob.word_filter || "Filter"}
			</MyButton>

			<span className="mx-1">&middot;</span>
			<CTooltip content={"--"+(uBahasaob.caption_resetdata||"Reset View Tampilan")}>
			<CLink onClick={()=>hdlKlikReset()} className="classikon classikonreset classcursorpointer" />
			</CTooltip>
			
			<span className="me-1">&middot;</span>
			(<strong id="idjmldata" className="text-primary">0</strong>&nbsp;
			{uBahasaob.word_data||"Data"})
		</div>
		</>
	)
}

export default Headersublapkasir
